module.exports = __webpack_public_path__ + "plane-twilight-red.9cb58403ffb66ff010cc.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/plane-twilight-red.svg
// module id = ../../../../../src/assets/img/plane-twilight-red.svg
// module chunks = main